import {useState} from 'react'
import {useCustomMutation} from '@salesforce/commerce-sdk-react'
import logger from '@salesforce/retail-react-app/app/utils/logger-instance'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'
import usedDeviceDetection from '../../../hooks/use-device-detection'
import {useBrand, toBrandCode} from '../../../contexts/brand-context'

const useSmsSubscription = ({email, phone, type, source}) => {
    const [isLoading, setIsLoading] = useState(true)
    const {site, locale} = useMultiSite()
    const {brandId} = useBrand()
    const device = usedDeviceDetection()

    const {mutateAsync: submitSmsSubscription} = useCustomMutation({
        options: {
            method: 'POST',
            parameters: {
                siteId: site.id,
                locale: locale?.id
            },
            body: JSON.stringify({
                email: email,
                phone: phone,
                type: type,
                source: source,
                brand: toBrandCode(brandId),
                device: device
            }),
            customApiPathParameters: {
                apiVersion: 'v1',
                endpointPath: '/newsletter-subscription',
                apiName: 'sfsc'
            }
        }
    },
    {
        onSuccess: () => {
            setIsLoading(false)
        },
        onError: (error) => {
            setIsLoading(false)
            logger.error('Error submitting SMS subscription:', {
                namespace: 'sms-subscription',
                additionalProperties: {error: error.message, stack: error.stack}
            })
        }
    })

    return {
        isLoading,
        submitSmsSubscription
    }
}

export {useSmsSubscription}
